enum RequestTypes {
  'EarliestPickup' = 'EarliestPickup',
  'LatestDelivery' = 'LatestDelivery',
  'EarliestLatest' = 'EarliestLatest',
}

export default RequestTypes;
